<kendo-label text="Select age range:" class="input-label-header"></kendo-label>
<hr class="input-label-header-hr" />
<div class="row">
  <div class="col">
    <kendo-rangeslider
      [(ngModel)]="selectedAgeRange"
      (valueChange)="updateSelections()"
      [min]="min"
      [max]="max"
      [largeStep]="largeStep"
      [smallStep]="smallStep"
      [style.width]="'100%'"
    ></kendo-rangeslider>
  </div>
</div>
<br />
<h6><span style="color: white;">Selection:</span> {{getSelectedRangeDisplayValue()}}</h6>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
